import { Button } from "@repo/ui";
import { useNavigate } from "react-router-dom";

export function Home() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="relative isolate overflow-hidden">
        <img
          src="https://images.pexels.com/photos/7113861/pexels-photo-7113861.jpeg"
          alt="Matcha tea with bamboo whisk on a white surface"
          className="absolute inset-0 -z-10 h-full w-full object-cover opacity-25"
        />
        <div className="mx-auto max-w-6xl px-6 pt-28 pb-20 md:pt-40 md:pb-28">
          <div className="max-w-2xl">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-secondary px-3 py-1 text-sm text-secondary-foreground">
              Bangkok, Thailand — Est. 2025
            </div>
            <h1 className="text-4xl md:text-6xl font-semibold leading-tight tracking-tight">
              Sora Cha
            </h1>
            <p className="mt-4 max-w-xl text-base md:text-lg text-muted-foreground">
              Artisanal green tea, curated in Bangkok. Sourced with care, roasted with precision,
              and served with calm.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Button
                onClick={() => navigate("/menu")}
                className="bg-primary text-primary-foreground hover:opacity-95"
              >
                View Menu
              </Button>
              <a
                href="#about"
                className="inline-flex items-center rounded-md border border-border px-4 py-2 text-sm hover:bg-secondary"
              >
                Our Story
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Highlights */}
      <section className="mx-auto max-w-6xl px-6 py-14 grid gap-6 md:grid-cols-3">
        <div className="rounded-xl border border-border bg-card p-6">
          <h3 className="font-semibold">Single-origin</h3>
          <p className="mt-2 text-sm text-muted-foreground">
            Carefully selected leaves from trusted growers.
          </p>
        </div>
        <div className="rounded-xl border border-border bg-card p-6">
          <h3 className="font-semibold">Freshly roasted</h3>
          <p className="mt-2 text-sm text-muted-foreground">
            Roasted weekly for peak aroma and flavor.
          </p>
        </div>
        <div className="rounded-xl border border-border bg-card p-6">
          <h3 className="font-semibold">Sustainable packaging</h3>
          <p className="mt-2 text-sm text-muted-foreground">Minimal, recyclable materials only.</p>
        </div>
      </section>

      {/* About */}
      <section
        id="about"
        className="mx-auto max-w-6xl px-6 pb-24 grid gap-10 md:grid-cols-2 items-center"
      >
        <div>
          <img
            src="https://images.pexels.com/photos/8329639/pexels-photo-8329639.jpeg"
            alt="Serene matcha preparation on wooden tray"
            className="w-full rounded-xl border border-border object-cover"
          />
        </div>
        <div>
          <h2 className="text-2xl md:text-3xl font-semibold">Rooted in calm</h2>
          <p className="mt-4 text-muted-foreground">
            We are a Bangkok-based tea shop specializing in premium Japanese-style green teas. Visit
            us in Ari or order online for local delivery.
          </p>
          <div className="mt-6 grid gap-2 text-sm">
            <div>Hours: Tue–Sun, 10:00–18:00</div>
            <div>Address: Ari, Phaya Thai, Bangkok</div>
            <div>Contact: hello@soracha.th</div>
          </div>
          <div className="mt-8">
            <Button variant="outline" onClick={() => navigate("/menu")}>
              Explore the Menu
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
}
